// extracted by mini-css-extract-plugin
export var completionBody = "_hm-2";
export var completionCard = "_hm-0";
export var completionFooter = "_hm-3";
export var completionTitle = "_hm-1";